const getDefaultState = () => {
	return {
		reportList: [],
		loading: false,
	}
}

const state = () => ({
	...getDefaultState(),
})

const getters = {
	getReportList: state => state.reportList,
	getLoading: state => state.loading,
}

const actions = {
	async fetch({ commit }) {
		try {
			commit('setLoading', true)
			const res = await this.$axios.get('/reports')
			if (res.status === 200) {
				commit('setReportList', res.data)
			}
		} catch (err) {
			console.log(err)
		} finally {
			commit('setLoading', false)
		}
	},
}

const mutations = {
	resetState(state) {
		Object.assign(state, getDefaultState())
	},
	setReportList(state, list) {
		state.reportList = list
	},
	setLoading(state, loading) {
		state.loading = loading
	},
}

export default {
	state,
	actions,
	mutations,
	getters,
}
